<script>
	import Leader from '$lib/icons/leadership-svgrepo-com.svelte';
	import Group from '$lib/icons/group-svgrepo-com.svelte';
	import Graph from '$lib/icons/graph-analytics-business-2-svgrepo-com.svelte';
</script>

<div class="content-div">
	<span class="chip static-courser bg-[#B93F4A] mt-4 text-white"><b>WP 2</b></span>
	<div class="flex">
		<h1 class="content-heading">
			Synthesis of comprehensive information on climate change impacts
		</h1>
		<Graph />
	</div>

	<blockquote class="content-blockquote">
		This WP will develop a range of indicators of climate change impacts across the sectors of
		water, agriculture and biodiversity that will be used to inform engagements with various actors
		to co-develop appropriate adaptation actions.
	</blockquote>

	<div class="flex pt-10">
		<Leader />
		<div class="pl-4 text-lg">
			<a class="anchor" href="/team/#kawawa_banda">Kawawa Banda (UNZA IWRMC )</a>
		</div>
	</div>

	<div class="flex pt-4">
		<Group />
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#uni_jena">Uni Jena</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#wits_gci">WITS-GCI</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#gerics">GERICS</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#ub">UB</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#unza_iwemc">UNZA-IWRMC</a></div>
		<div class="pl-4 text-lg"><a class="anchor" href="/team/#gobabeb">Gobabeb</a></div>
	</div>

	<h2 class="h4 pt-10 pb-2">Objectives</h2>
	The analysis of climate change induced tipping points in the southern African region towards the provision
	of climate services such as informing adaptation actions and policy require a reliable scientific base
	quantifying climate change impacts across various sectors. This WP will develop such a base, in the
	form of a range of indicators of climate change impacts across the sectors of water, agriculture and
	biodiversity that will be used to inform engagements with various actors to co-develop appropriate
	adaptation actions. These measures will range from indices of meteorological and hydrological drought,
	to simulations of soil moisture, indices of heat-stress in cattle, simulations of crop yield and estimates
	of soil degradation. Where possible actors will be engaged to include their experiences of using such
	indicators, which have been most useful and which not, and then how can these be improved? The indicators
	will thus be based on the comprehensive set of projections of future climate change described in WP1,
	and will be also worked into engagements with users up front in efforts to co-design useful outputs
	and then options for effective actions for dissemination will be work-shopped and co-produced further
	through WP3. It is expected that these products will find wide application across the southern African
	region in terms of climate change impacts – far beyond the reach of this project. However, the indicators
	are also of critical importance for the assessment of regional tipping points as per WP4 of the project.
</div>
